enum GuiidePlusView {
  Dashboard,
  Providers,
  PensionManagement,
  Advisers,
  GuaranteedIncome,
  StatePensionHelp,
  LumpsSumsAndTax,
  BenefitsAndCredits,
  EquityRelease,
  PartnersIncome,
  WhyPayMore,
  OtherWaysToSave,
  HelpAndEduction,
  FinancialCoaching
}

export default GuiidePlusView;
